import {
  arrayOf,
  customType,
  namedFragment,
  params,
  shape,
  string,
  typename,
} from '@thd-nucleus/data-sources';
import { HeroFlattenImage } from '../../HeroFlattenImage';
import {
  ADOBE_TARGET, INNERVATE, MULTI_ARM_BANDIT, COMPONENT_SELECTOR, COMPONENT_CLASS
} from '../constants';

const targetingTypeShape = shape({
  AdobeTarget: namedFragment({
    inline: true,
    fragmentType: ADOBE_TARGET,
  }).shape({
    id: string(),
    mbox: string(),
    __typename: typename(ADOBE_TARGET)
  }),
  Innervate: namedFragment({
    inline: true,
    fragmentType: INNERVATE,
  }).shape({
    id: string(),
    tagID: string(),
    adkey: string(),
    __typename: typename(INNERVATE)
  }),
  // MultiArmBandit isn't being used but it is included here because taking it out may cause issues until it is fully
  // removed from ComponentSelector logic.
  MultiArmBandit: namedFragment({
    inline: true,
    fragmentType: MULTI_ARM_BANDIT,
  }).shape({
    id: string(),
    campaignId: string(),
    __typename: typename(MULTI_ARM_BANDIT)
  }),
});

const HeroFlattenImageSlot = {};
HeroFlattenImageSlot.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType(COMPONENT_CLASS).enum(['Slot']).isRequired(),
  }).shape({
    Slot: namedFragment({
      inline: true,
      fragmentType: 'Slot',
      fragmentAlias: 'HeroFlattenImageSlot',
    }).shape({
      componentName: string(),
      id: string(),
      slotNumber: string(),
      content: shape({
        ...HeroFlattenImage.dataModel.component,
      }),
    }),
  }),
};

const BentoHeroSelector = {};
BentoHeroSelector.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType(COMPONENT_CLASS).enum([COMPONENT_SELECTOR]).isRequired(),
  }).shape({
    ComponentSelector: namedFragment({
      inline: true,
      fragmentType: COMPONENT_SELECTOR,
      fragmentAlias: 'BentoHeroSelector',
    }).shape({
      componentName: string(),
      id: string(),
      targetingType: targetingTypeShape,
      defaultComponent: shape({
        ...HeroFlattenImageSlot.dataModel.component,
      }),
      variations: arrayOf(
        shape({
          ...HeroFlattenImageSlot.dataModel.component,
        }),
      ),
      __typename: typename(COMPONENT_SELECTOR),
    }),
  }),
};

export { BentoHeroSelector };
